import jwt from "jwt-decode";
import { differenceInHours, differenceInMinutes } from "date-fns";
import { Roles } from "../interfaces";

export interface Token {
    id: string;
    refId: string;
    nome: string;
    reset: string;
    role: Roles;

    nbf: number;
    exp: number;
    iat: number;
    jti: string;
}

export const TOKEN_KEY: string = "@aliancaApp-Token";

export const GetToken = () => localStorage.getItem(TOKEN_KEY);

export const Login = (token: string) => {
    localStorage.setItem(TOKEN_KEY, token);
};

export const Logout = () => {
    localStorage.removeItem(TOKEN_KEY);
};

export const GetUser = () => {
    const token = localStorage.getItem(TOKEN_KEY);

    // Decode header do token example
    // const decodedTokenHeader = jwt<TokenHeaderDto>(String(token), {
    //     header: true,
    // });

    // Decode payload do token
    return jwt<Token>(String(token));
}

export const IsExpired = () => {
    const decodedTokenPayload = GetUser();

    const expires = decodedTokenPayload.exp * 1000;
    const now = new Date();

    const diference = differenceInHours(expires, now);
    const expired = diference <= 0;
    return expired;
};

export const TimeRemeaning = () => {

    const decodedTokenPayload = GetUser();
    const expires = decodedTokenPayload.exp * 1000;

    const now = new Date();
    const diference = differenceInMinutes(expires, now);

    return diference;
}

export const IsAuthenticated = () => {
    const token: boolean = localStorage.getItem(TOKEN_KEY) !== null;

    if (token) {
        return !IsExpired();
    }
}

export const IsChangePassword = () => {
    const token: boolean = localStorage.getItem(TOKEN_KEY) !== null;

    if (token) {
        return GetUser().reset === "True";
    }
}
